import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import React, { useState } from 'react';
import { useEnhancedEffect, Nav } from '@landr/maestro';
import { getGraphqlWsUri, getGraphqlHttpUri } from '@landr/core';
import { ApolloProvider } from '@apollo/client';
import { i18n } from '@lingui/core';
import { createApolloClient } from '../../utils/apollo/apolloClient.es.js';
import { NavBarProvider } from '../../contexts/NavBarProvider/NavBarProvider.es.js';
import { NavBarContent } from './components/NavBarContent/NavBarContent.es.js';

var NavBar = function NavBar(_ref) {
  var env = _ref.env,
    language = _ref.language,
    onLogin = _ref.onLogin,
    onLogout = _ref.onLogout,
    user = _ref.user,
    _ref$hasNotifications = _ref.hasNotifications,
    hasNotifications = _ref$hasNotifications === void 0 ? false : _ref$hasNotifications,
    _ref$isUserLoading = _ref.isUserLoading,
    isUserLoading = _ref$isUserLoading === void 0 ? false : _ref$isUserLoading,
    chatClientService = _ref.chatClientService,
    _ref$config = _ref.config,
    config = _ref$config === void 0 ? {} : _ref$config,
    locationPathname = _ref.locationPathname,
    _ref$hasDesktopNotifi = _ref.hasDesktopNotifications,
    hasDesktopNotifications = _ref$hasDesktopNotifi === void 0 ? false : _ref$hasDesktopNotifi,
    _ref$isVisible = _ref.isVisible,
    isVisible = _ref$isVisible === void 0 ? true : _ref$isVisible,
    _ref$isSessionsPicker = _ref.isSessionsPickerVisible,
    isSessionsPickerVisible = _ref$isSessionsPicker === void 0 ? false : _ref$isSessionsPicker;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    apolloClient = _useState2[0],
    setApolloClient = _useState2[1];
  useEnhancedEffect(function () {
    if (config.applicationName && config.applicationVersion) {
      setApolloClient(createApolloClient(getGraphqlHttpUri(env, {
        isLocal: config.isLocal
      }), getGraphqlWsUri(env, config.isLocal), config.applicationName, config.applicationVersion, config.authorizationToken, i18n, config.log));
    }
  }, [config.applicationName, config.applicationVersion, config.authorizationToken, config.isLocal, config.log, env, hasNotifications]);
  var defaultProviderProps = {
    env: env,
    language: language,
    onLogin: onLogin,
    onLogout: onLogout,
    user: apolloClient ? user : null,
    hasNotifications: hasNotifications,
    chatClientService: chatClientService || null,
    isUserLoading: isUserLoading,
    locationPathname: locationPathname,
    hasDesktopNotifications: hasDesktopNotifications,
    isSessionsPickerVisible: isSessionsPickerVisible
  };
  if (!isVisible) {
    return null;
  }
  if (user && apolloClient) {
    return /*#__PURE__*/React.createElement(ApolloProvider, {
      client: apolloClient
    }, /*#__PURE__*/React.createElement(NavBarProvider, Object.assign({}, defaultProviderProps, {
      config: config
    }), /*#__PURE__*/React.createElement(NavBarContent, {
      isAuthenticated: !!user
    })));
  }
  return /*#__PURE__*/React.createElement(NavBarProvider, Object.assign({}, defaultProviderProps, {
    hasNotifications: false
  }), /*#__PURE__*/React.createElement(NavBarContent, {
    isAuthenticated: !!user
  }));
};
NavBar.displayName = 'NavBar';
NavBar.Item = Nav.Item;
NavBar.Link = Nav.Link;

export { NavBar };
